// extracted by mini-css-extract-plugin
export default {"root":"o9grpA89","button":"FFl5w49z","button_purple":"hlzvSskB","buttonPurple":"hlzvSskB","icon":"Rj2BmLq8","label":"Q2i0O_mK"};